import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWrench = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.8 4.2C9.67785 4.32462 9.60943 4.49216 9.60943 4.66667C9.60943 4.84117 9.67785 5.00871 9.8 5.13333L10.8667 6.2C10.9913 6.32215 11.1588 6.39057 11.3333 6.39057C11.5078 6.39057 11.6754 6.32215 11.8 6.2L13.8707 4.13C14.084 3.91533 14.446 3.98333 14.526 4.27533C14.7274 5.00792 14.716 5.78271 14.4932 6.50906C14.2703 7.23541 13.8452 7.88327 13.2676 8.37683C12.69 8.87038 11.9837 9.18923 11.2315 9.29604C10.4793 9.40286 9.71219 9.29324 9.02 8.98L3.74667 14.2533C3.48145 14.5185 3.12177 14.6674 2.74676 14.6673C2.37175 14.6672 2.01213 14.5182 1.747 14.253C1.48187 13.9878 1.33296 13.6281 1.33302 13.2531C1.33308 12.8781 1.48212 12.5185 1.74733 12.2533L7.02067 6.98C6.70743 6.28781 6.5978 5.52072 6.70462 4.7685C6.81144 4.01628 7.13028 3.31003 7.62384 2.73241C8.1174 2.15479 8.76526 1.72967 9.49161 1.50682C10.218 1.28396 10.9928 1.27258 11.7253 1.474C12.0173 1.554 12.0853 1.91533 11.8713 2.13L9.8 4.2Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgWrench;
